import PageTemplate from "../components/common/PageTemplate";
import PurchasePaymentMethodNew from "../screen/purchase/checkout/PurchasePaymentMethodNew";

const PurchasePaymentMethodPage = () => {
  return (
    <PageTemplate
      mainComponent={<PurchasePaymentMethodNew />}
      noPadding={true}
      logo="Metode Pembayaran"
    />
  );
};

export default PurchasePaymentMethodPage;
